export enum StorageFilterType {
    EXCLUDE = "EXCLUDE",
    RESTRICT = "RESTRICT"
}